import { render, staticRenderFns } from "./ServiceCoverages.vue?vue&type=template&id=f7a5adf8"
import script from "./ServiceCoverages.vue?vue&type=script&lang=js"
export * from "./ServiceCoverages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports